module.exports = __webpack_public_path__ + "img/Clarke-County-Students-at-Grady.80eea63c.jpg";